// USER
export function getUser(state) {
  return state.auth.user;
}
export function getUserId(state) {
  return state.auth.user ? state.auth.user.objectId : null;
}
export function isAnonymousUser(state) {
  return state.auth.user.email == null;
}
export function getFamilyName(state) {
  const user = state.auth.user;
  return user ? user.familyName : undefined;
}
export function hasPremium(state) {
  const { subscription } = state.auth.user;
  const { lastSyncDate } = state.auth;
  if (!subscription) return false;
  return new Date(subscription.expirationDate) > new Date(lastSyncDate);
}
export function canManageSubscription(state) {
  return (
    hasPremium(state) &&
    getSubscription(state).cancelUrl &&
    getSubscription(state).updateUrl
  );
}
export function getSubscription(state) {
  return state.auth.user.subscription;
}
export function hadPremiumBefore(state) {
  const { subscription } = state.auth.user;
  return Boolean(subscription);
}
export function hasFamilyAccount(state) {
  return Boolean(state.auth.user.email);
}

export function isFreemium(state) {
  const hasActivePremium = hasPremium(state);
  return !hasActivePremium;
}

// DEVICE
export function getXmppCredentials(state) {
  return state.auth.device.xmppCredentials;
}
export function getXmppLogin(state) {
  const xmppCredentials = getXmppCredentials(state);
  return xmppCredentials ? xmppCredentials.xmppLogin : undefined;
}
export function getXmppPassword(state) {
  const xmppCredentials = getXmppCredentials(state);
  return xmppCredentials ? xmppCredentials.xmppPassword : undefined;
}
export function getDeviceName(state) {
  return state.auth.device.name;
}

export function getDevice(state) {
  return state.auth.device;
}

export function getDeviceOriginalName(state) {
  return state.auth.device.originalName || state.auth.device.name;
}
